import React, {useState} from 'react';
import TableReport from "../../common/table/table";
import ClientDailiesTable from "./clientDailiesTable";
import MessageEmptyData from "../../common/messageEmptyData";
import ModalConfirmation from "../../common/modal/ModalConfirmation";
import apiClient from "../../../utils/apiClient";
import {toast} from "react-toastify";
import * as ArrayHelpers from "../../../utils/arrayHelpers";

/**
 * @param prop
 * @returns {JSX.Element|null}
 * @constructor
 */
const ClientDailiesBody = (prop) => {
    const {filters, setFilters, tableData, setTableData, selectedRow, setSelectedRow, setFormModal} = prop;
    const [approveModal, setApproveModal] = useState({isOpen: false, message: <p></p>});
    const [disapproveModal, setDisapproveModal] = useState({isOpen: false, message: <p></p>});

    const ApproveHandler = () => {
        apiClient
            .post('clientApproveDaily/' + selectedRow.daily_id)
            .then(response => {
                setTableData(
                    ArrayHelpers.multiReplacePartialObjFromArray(
                        tableData, "daily_id", response.data.id, response.data.row
                    )
                );
                toast.success(response.data.message);
            })
            .then(function () {
                //close deactivateModal
                setApproveModal({...approveModal, isOpen: false})
            });
    }

    const DisapproveHandler = () => {
        apiClient
            .post('clientDisproveDaily/' + selectedRow.daily_id)
            .then(response => {
                setTableData(
                    ArrayHelpers.multiReplacePartialObjFromArray(
                        tableData, "daily_id", response.data.id, response.data.row
                    )
                );
                toast.success(response.data.message);
            })
            .then(function () {
                //close deactivateModal
                setDisapproveModal({...disapproveModal, isOpen: false})
            });
    }

    if (!filters.isSubmitted) {
        return null;
    }

    if (tableData.length === 0) {
        return <MessageEmptyData/>;
    }

    return (
        <div className="container-fluid">
            <TableReport
                columns={
                    ClientDailiesTable(
                        setFilters, setSelectedRow, setApproveModal, setDisapproveModal, setFormModal
                    )
                }
                data={tableData}
                exportOptions={{pdf: false, xlsx: true, csv: true}}
                getExportFileName={() => 'client_dailies'}
                withGlobalSearch={true}
                scrollable={true}
            />
            <ModalConfirmation
                modal={approveModal}
                setModal={setApproveModal}
                title="Approve Daily"
                onConfirm={ApproveHandler}
            />
            <ModalConfirmation
                modal={disapproveModal}
                setModal={setDisapproveModal}
                title="Disapprove Daily"
                onConfirm={DisapproveHandler}
            />
        </div>
    );
}

export default ClientDailiesBody;
